
import styles from "./form_heading.module.scss";



const FormHeading = ({
  title,
  subtitle,
  description,
  type,
  className,
  calledForm
}) => {
  return (
    <div className={`mb-4 ${className} ${calledForm === 'auth' ? styles.auth_type_header : ''} ` }>
      <div
        className={` ${type === "center" ? "justify-content-center" : ""} ${
          styles.heading
        }`}
      >
        <div className={`${styles.title} h0-j mb-1`}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
      <div
        className={`${styles.description} mt-1 ${
          type === "center" ? "text-center px-1" : ""
        }`}
      >
        {description}
      </div>
    </div>
  );
};

export default FormHeading;
